import { removeSecureItem } from "@/Utils/SecureStorage";

export function logout(router) {
  removeSecureItem("qr-token");
  removeSecureItem("role");
  localStorage.removeItem("auth_store"); // Clear persisted auth state
  if (router) {
    router.push("/login");
  } else {
    window.location.href = "/login";
  }
}
